import React, {useState, memo, useEffect} from "react";
import HeaderPage from "../../Component/HeaderPage/HeaderPage";
import Table from '../../Component/Table/Table'
import TableFilter from "../../Component/TableFilter/TableFilter";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import classNames from "classnames";

import './index.css'
import classes from "./styles";
import {dividerClasses} from "@material-ui/core";

const URL_SUMO_LOGIC = "https://apm-app3.alphait.us/SumoLogic/FetchSumoLogicData"

const INPUT_PLACEHOLDER = 'Type your search here then hit Start button to execute.'

const RANGE_VALUES = ['15m', '60m', '3h', '6h', '24h', 'today', 'yesterday', '3d', '7d', 'this week', 'previous week', '14d', '30d', 'this month', 'previous month']

const RANGE_LABEL = {
    '15m': 'Last 15 Minutes',
    '60m': 'Last 60 Minutes',
    '3h': 'Last 3 Hours',
    '6h': 'Last 6 Hours',
    '24h': 'Last 24 Hours',
    'today': 'Today',
    'yesterday': 'Yesterday',
	'3d': 'Last 3 Days',
    '7d': 'Last 7 Days',
    'this week': 'This week',
    'previous week': 'Previous week',
    '14d': 'Last 14 Days',
    '30d': 'Last 30 Days',
    'this month': 'This month',
    'previous month': 'previous month',
}

const SumoLogic = () => {
    const [active, setActive] = useState(false);
    const [filterData, setFilterData] = useState();
    const [loading, setLoading] = useState(false);
    const [initSumoLogic, setInitSumoLogic] = useState(true)
    const [dataset, setData] = useState([]);
    const [values, setValues] = React.useState({
        text: '',
        range: ''
    });

    useEffect(() => {
        const URL = "https://apm-app3.alphait.us/SumoLogic/GetSumoLogicData"

        fetch(URL)
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                setData(data);
            });

    }, []);

    const handleFetchSumoLogicData = () => {

        if ([values.text,values.range].some(el => el.length === 0)) return null

        const replaceQuote = values.text.toString().replace(/"/g, "'");

        const data = {"query" : `${replaceQuote}`,
            "timestamp": `${values.range}`}

        fetch(URL_SUMO_LOGIC, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            referrerPolicy: 'no-referrer',
            body: JSON.stringify(data)
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                setFilterData(data);
                setInitSumoLogic(!initSumoLogic);
                setLoading(true)
            });
    }

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    const initSumoLogicRender = () => {
        if (dataset && dataset.dataList) {
            return (
                <Table list={dataset && dataset.dataList}/>
            )
        } else {
            return (
                <div className="service-loading">
                    <span className="service-loading-label">Loading data from server...</span>
                    <CircularProgress/>
                </div>
            )
        }
    }

    const filterSumoLogicRender = () => {
        return (
            <TableFilter list={filterData}/>
        )
    }

    return (
        <div className="sumo-logic-sub">
            <HeaderPage text="sumo logic" />
            <div className="sumo-filter">
                <FormControl className="sumo-input">
                    <InputLabel className="sumo-input-label" id="demo-simple-select-label" >Search text</InputLabel>
                    <Input
                        id="standard-adornment-amount"
                        value={values.text}
                        placeholder={INPUT_PLACEHOLDER}
                        onChange={handleChange('text')}
                        startAdornment={<InputAdornment position="start">$</InputAdornment>}
                    />
                </FormControl>
                <FormControl className="sumo-dropdown">
                    <InputLabel id="demo-simple-select-label" >Time range</InputLabel>
                    <Select
                        classes={{ root: classes.test }}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={values.range}
                        onChange={handleChange('range')}
                    >
                        {RANGE_VALUES.map((item) => <MenuItem key={item} value={item}>{RANGE_LABEL[`${item}`]}</MenuItem>)}
                    </Select>
                </FormControl>
                <div style={{ marginRight: '16px' }}>
                    <span
                        key='start'
                        className={classNames('dashboard-button')}
                        onClick={() => handleFetchSumoLogicData()}
                    >
                      Start
                    </span>
                </div>
            </div>
            { initSumoLogic ? initSumoLogicRender() : filterSumoLogicRender() }
        </div>
    )
}

export default memo(SumoLogic)